import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { notify } from "@/shared/notification";

export const useActualizarDatosDEMutation = (options: { onSuccess?: () => void } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (deId: string) => {
            const response = await api.put(`/de/${deId}/actualizar-datos`);
            return response.data;
        },
        onSuccess: (data) => {
            notify("Datos del DE actualizados correctamente", { variant: "success" });
            
            queryClient.invalidateQueries({ queryKey: ["documentos-electronicos"] });
            queryClient.invalidateQueries({ queryKey: ["de", data.de?.id] });
            
            options.onSuccess?.();
        },
        onError: (error: any) => {
            const message = error.response?.data?.message || "Error al actualizar los datos del DE";
            notify(message, { variant: "error" });
        },
    });
};
